;(function () {
  /**
   * Validate Turkish ID number using checksum algorithm
   * Algorithm: https://gist.github.com/canerbasaran/5935004
   *
   * @param {string} id - The 11-digit Turkish ID number as a string
   * @returns {boolean} - True if valid, false otherwise
   * @example
   * turkishIdNumberValid('10000000146') // returns true
   * turkishIdNumberValid('12345678901') // returns false
   */
  const turkishIdNumberValid = function (id) {
    // Must be exactly 11 digits
    if (!/^\d{11}$/.test(id)) {
      return false
    }

    // Convert to string and extract digits
    const digits = id
      .substring(0, 9)
      .split("")
      .map((d) => parseInt(d, 10))
    const digit9 = parseInt(id[9], 10)
    const digit10 = parseInt(id[10], 10)

    // Calculate check9: ((sum of odd positions * 7) - sum of even positions) % 10
    // Odd positions are indices 0, 2, 4, 6, 8 (1st, 3rd, 5th, 7th, 9th digits)
    const sumOdd = digits
      .filter((_, i) => i % 2 === 0)
      .reduce((a, b) => a + b, 0)
    const sumEven = digits
      .filter((_, i) => i % 2 === 1)
      .reduce((a, b) => a + b, 0)
    const check9 = (((sumOdd * 7 - sumEven) % 10) + 10) % 10

    // Calculate check10: (sum of all first 9 digits + check9) % 10
    const sumAll = digits.reduce((a, b) => a + b, 0)
    const check10 = (sumAll + check9) % 10

    // Validate that the 10th and 11th digits match the checksums
    return digit9 === check9 && digit10 === check10
  }

  /**
   * Validate Turkish TIN (VKN - Tax Identification Number)
   * Algorithm: https://gist.github.com/defiant/18387fb096a8581e1b2e9968ea016e50
   *
   * @param {string} tin - The 10-digit Turkish TIN as a string
   * @returns {boolean} - True if valid, false otherwise
   * @example
   * TINValidation('1234567890') // returns true
   * TINValidation('0000000000') // returns false
   */
  const TINValidation = function (tin) {
    if (typeof tin !== "string") {
      return false
    }
    if (tin.length !== 10) {
      return false
    }

    const digits = tin.split("")
    const control = digits.pop() // eslint-disable-line

    const r = []

    digits.forEach((el, i) => {
      const x = Number(el) + 10 - (i + 1)
      const mod = x % 10
      if (mod === 9) {
        r.push(mod)
      } else {
        const pow = 2 ** (10 - (i + 1))
        r.push((mod * pow) % 9)
      }
    })

    const total = r.reduce((acc, cur) => acc + cur)
    const c = (10 - ((total % 10) % 10)) % 10

    return `${digits.join("")}${c}` === tin
  }

  if (!window.HB) {
    window.HB = {}
  }
  window.HB.turkishIdNumberValid = turkishIdNumberValid
  window.HB.TINValidation = TINValidation
})()
